// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PInfoCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PInfoCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PInfoCircleOutlined = function PInfoCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PInfoCircleOutlinedSvg
  }));
};

PInfoCircleOutlined.displayName = 'PInfoCircleOutlined';
export default React.forwardRef(PInfoCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PInfoCircleOutlined.js
// module id = 3457
// module chunks = 0